<template>
  <qx-card-form title="交车时是否满油">
    <span slot="titleLeft">
      <span style="margin-left: 16px" class="error"
        >是否满油用于计算在多个订单间分摊的油费，请以公司的交车标准为准</span
      >
    </span>
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <span slot="isFullOilTip" class="error" style="margin-left: 16px">如果是交车加满油，请选择是，否则选择否。用于计算在多个订单间分摊的油费，请以公司的交车标准为准</span>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
export default {
  data () {
    return {
      baseForm: {
        form: [
          {
            label: '是否满油',
            value: 'isFullOil',
            type: 'radio',
            default: 0,
            disabled: false,
            options: [
              {
                label: '未满',
                value: 0,
              },
              {
                label: '已满',
                value: 1,
              },
            ],
          },
          {
            label: '是否可以修改',
            value: 'isAuditPass',
            type: 'input',
            default: 0,
            disabled: false,
            hide: true,
          },
        ],
        rules: {
          isFullOil: [ // 是否满油
            { required: true, message: '请选择是否满油', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {

    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      return formData;
    },

    setDisabledByState (disabled) {
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'disabled',
        value: disabled,
      });
    },

    setFormState (data) {
      this.setDisabledByState(false);
      if (data.isAuditPass === 1) {
        this.setDisabledByState(true);
      }
    },

    async sub () {
      const formData = await this.handleSubData();
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData(true);
      return res;
    },
    async init (data = {}) {
      if (!data.isFullOil) {
        data.isFullOil = 0;
      }
      this.$refs.baseForm.setVal(data);
      this.setFormState(data);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
